import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api';

const MallCtx = createContext(null);

export function MallProvider({ children }) {
    const [selectedMall, setSelectedMall] = useState(null);
    const [allMalls, setAllMalls] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get('/malls').then(({ data }) => {
            setAllMalls(data);
            const saved = localStorage.getItem('io_selected_mall');
            let chosen = null;
            if (saved) chosen = data.find((x) => x.slug === saved);
            // Default to Inorbit Malad (Mumbai flagship) if nothing saved
            if (!chosen) chosen = data.find((x) => x.slug === 'malad') || data[0];
            if (chosen) {
                setSelectedMall(chosen);
                localStorage.setItem('io_selected_mall', chosen.slug);
            }
            setLoading(false);
        }).catch(() => setLoading(false));
    }, []);

    const choose = useCallback((slug) => {
        const m = allMalls.find((x) => x.slug === slug);
        if (m) { setSelectedMall(m); localStorage.setItem('io_selected_mall', slug); }
    }, [allMalls]);

    const clear = useCallback(() => {
        setSelectedMall(null);
        localStorage.removeItem('io_selected_mall');
    }, []);

    return (
        <MallCtx.Provider value={{ selectedMall, allMalls, loading, choose, clear }}>
            {children}
        </MallCtx.Provider>
    );
}

export const useMall = () => useContext(MallCtx);
